<template>
	<div
		class="widthFull section02 min-height-calc"
		id="award"
	>
		<div class="container py-4">

			<div class="row justify-content-center mb-3">

				<div class="col-12 center Bold pb-2 color-3 text-shadow ">
					<h4>Premio</h4>
					<h3> Una cena al giorno con chef <br> a casa tua! </h3>
				</div>

				<div class="col-12">
					<div class="mt-0 text-center">

						<button-custom
							v-if="timeStore < moment(finish)"
							:to=" !isAuthenticated ? '/' : '/play'"
							:scrollTo="'#section03'"
							:type="'inv'"
						> </button-custom>

						<div
							v-else
							class="Bold white"
						>Il concorso è terminato</div>

						<!-- <router-link
							v-if="!isAuthenticated"
							to="/"
							v-scroll-to="{ el: '#section03', offset: this.vw > 768 ? -this.navHeight : -this.navHeightSmall}"
							class="btn  btn-primary Bold uppercase"
						>
							Partecipa subito

						</router-link>
						<router-link
							v-else
							to="/play"
							class="btn  btn-primary Bold uppercase"
						>
							Partecipa subito

						</router-link> -->

					</div>
				</div>
			</div>

		</div>

	</div>
</template>


<script>
	import { mapGetters } from 'vuex';
	const moment = require('moment');

	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';
	import { innerWidthMixin } from '../../mixins/innerWidthMixin';

	export default {
		name: 'award',

		mixins: [sharedEnvMixin, innerWidthMixin],
		data() {
			return {
				oldPresent: false,
				moment: moment,
			};
		},
		methods: {},

		mounted: function () {},
		computed: {
			...mapGetters([
				'isAuthenticated',
				'authStatus',
				'getPromotions',
				'getOldPromotions',
			]),
			timeStore() {
				return this.$timestore.now;
			},
		},
	};
</script>
